import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  getProductsData() {
    return [
      {
        backupId: "1000",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1234",
        issuerName: "Armstrong Brian",

        cik: "0001234567",
        irs: "12-3456789",
        ein: "12-3456789",
        sic: "7372",
        analyst: "Robert",
        fileNumber: "001-23456",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "f230fh0g3",
        name: "Bamboo Watch",
        description: "Product Description",
        image: "bamboo-watch.jpg",
        price: 65,
        category: "Accessories",
        quantity: 24,
        inventoryStatus: "INSTOCK",
        rating: 5,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1000",
        insiderName: "Armstrong Brian",
        relation: "CEO",
        planAction: "Buy",
        adoptionDate: "01/15/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "06/20/2023",
        expirationDate: "01/15/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1000",
        securityType: "Common Stock",
        transactionType: "Open Market Purchase",
        maximumShares: 10000,
        aggregateShares: 5000,
        notionalValue: 325000,
      },
      {
        backupId: "1001",
        filingId: "4455",
        formType: "common A",
        accessionNumber: "1235",
        issuerName: "Jennifer Clark",
        cik: "0002345678",
        irs: "23-4567890",
        ein: "23-4567890",
        sic: "7373",
        analyst: "Robert",
        fileNumber: "002-34567",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "false",
        code: "nvklal433",
        name: "Black Watch",
        description: "Product Description",
        image: "black-watch.jpg",
        price: 72,
        category: "Accessories",
        quantity: 61,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1001",
        insiderName: "Jennifer Clark",
        relation: "CFO",
        planAction: "Sell",
        adoptionDate: "03/10/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "06/20/2023",
        expirationDate: "03/10/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1001",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 8000,
        aggregateShares: 4000,
        notionalValue: 288000,
      },
      {
        backupId: "1002",
        filingId: "5455",
        formType: "common A",
        accessionNumber: "1236",
        issuerName: "Michael Smith",
        cik: "0003456789",
        irs: "34-5678901",
        ein: "34-5678901",
        sic: "7374",
        analyst: "Robert",
        fileNumber: "003-45678",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "zz21cz3c1",
        name: "Blue Band",
        description: "Product Description",
        image: "blue-band.jpg",
        price: 79,
        category: "Fitness",
        quantity: 2,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
        tradingPlan: "Plan B",
        // First image fields
        planId: "TP-1002",
        insiderName: "Michael Smith",
        relation: "CTO",
        planAction: "Buy",
        adoptionDate: "02/05/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "08/15/2023",
        expirationDate: "02/05/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1002",
        securityType: "Common Stock",
        transactionType: "Open Market Purchase",
        maximumShares: 12000,
        aggregateShares: 6000,
        notionalValue: 474000,
      },
      {
        backupId: "1004",
        filingId: "6455",
        formType: "common A",
        accessionNumber: "1238",
        issuerName: "James Brown",
        cik: "0004567890",
        irs: "45-6789012",
        ein: "45-6789012",
        sic: "7375",
        analyst: "Robert",
        fileNumber: "004-56789",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "244wgerg2",
        name: "Blue T-Shirt",
        description: "Product Description",
        image: "blue-t-shirt.jpg",
        price: 29,
        category: "Clothing",
        quantity: 25,
        inventoryStatus: "INSTOCK",
        rating: 5,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1004",
        insiderName: "James Brown",
        relation: "Director",
        planAction: "Buy",
        adoptionDate: "04/22/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "06/20/2023",
        expirationDate: "04/22/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1004",
        securityType: "Common Stock",
        transactionType: "Open Market Purchase",
        maximumShares: 15000,
        aggregateShares: 7500,
        notionalValue: 217500,
      },
      {
        backupId: "1005",
        filingId: "7455",
        formType: "common A",
        accessionNumber: "1239",
        issuerName: "Emily Davis",
        cik: "0005678901",
        irs: "56-7890123",
        ein: "56-7890123",
        sic: "7376",
        analyst: "Robert",
        fileNumber: "005-67890",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "false",
        code: "h456wer53",
        name: "Bracelet",
        description: "Product Description",
        image: "bracelet.jpg",
        price: 15,
        category: "Accessories",
        quantity: 73,
        inventoryStatus: "INSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1006",
        filingId: "8455",
        formType: "common A",
        accessionNumber: "1240",
        issuerName: "Christopher Garcia",
        cik: "0006789012",
        irs: "67-8901234",
        ein: "67-8901234",
        sic: "7377",
        analyst: "Robert",
        fileNumber: "006-78901",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "av2231fwg",
        name: "Brown Purse",
        description: "Product Description",
        image: "brown-purse.jpg",
        price: 120,
        category: "Accessories",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "01/15/2024",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1007",
        filingId: "9455",
        formType: "common A",
        accessionNumber: "1241",
        issuerName: "Patricia Martinez",
        cik: "0007890123",
        irs: "78-9012345",
        ein: "78-9012345",
        sic: "7378",
        analyst: "Robert",
        fileNumber: "007-89012",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "bib36pfvm",
        name: "Chakra Bracelet",
        description: "Product Description",
        image: "chakra-bracelet.jpg",
        price: 32,
        category: "Accessories",
        quantity: 5,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
        tradingPlan: "Plan B",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1008",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1242",
        issuerName: "Robert Rodriguez",
        cik: "0008901234",
        irs: "89-0123456",
        ein: "89-0123456",
        sic: "7379",
        analyst: "Robert",
        fileNumber: "008-90123",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "false",
        code: "mbvjkgip5",
        name: "Galaxy Earrings",
        description: "Product Description",
        image: "galaxy-earrings.jpg",
        price: 34,
        category: "Accessories",
        quantity: 23,
        inventoryStatus: "INSTOCK",
        rating: 5,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1009",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1243",
        issuerName: "Linda Wilson",
        cik: "0009012345",
        irs: "90-1234567",
        ein: "90-1234567",
        sic: "7380",
        analyst: "Robert",
        fileNumber: "009-01234",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "vbb124btr",
        name: "Game Controller",
        description: "Product Description",
        image: "game-controller.jpg",
        price: 99,
        category: "Electronics",
        quantity: 2,
        inventoryStatus: "LOWSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1010",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1244",
        issuerName: "Thomas Lee",
        cik: "0010123456",
        irs: "01-2345678",
        ein: "01-2345678",
        sic: "7381",
        analyst: "Robert",
        fileNumber: "010-12345",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "false",
        code: "cm230f032",
        name: "Gaming Set",
        description: "Product Description",
        image: "gaming-set.jpg",
        price: 299,
        category: "Electronics",
        quantity: 63,
        inventoryStatus: "INSTOCK",
        rating: 3,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1011",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1245",
        issuerName: "Barbara Walker",
        cik: "0011234567",
        irs: "12-3456789",
        ein: "12-3456789",
        sic: "7382",
        analyst: "Robert",
        fileNumber: "011-23456",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "plb34234v",
        name: "Gold Phone Case",
        description: "Product Description",
        image: "gold-phone-case.jpg",
        price: 24,
        category: "Accessories",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1012",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1246",
        issuerName: "Daniel Hall",
        cik: "0012345678",
        irs: "23-4567890",
        ein: "23-4567890",
        sic: "7383",
        analyst: "Robert",
        fileNumber: "012-34567",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "true",
        code: "4920nnc2d",
        name: "Green Earbuds",
        description: "Product Description",
        image: "green-earbuds.jpg",
        price: 89,
        category: "Electronics",
        quantity: 23,
        inventoryStatus: "INSTOCK",
        rating: 4,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
      {
        backupId: "1013",
        filingId: "3455",
        formType: "common A",
        accessionNumber: "1247",
        issuerName: "Elizabeth Allen",
        cik: "0013456789",
        irs: "34-5678901",
        ein: "34-5678901",
        sic: "7384",
        analyst: "Robert",
        fileNumber: "013-45678",
        yearEnd: "12/31",
        sourceUrl: "https://10b5.vercel.app/",
        locked: "false",
        code: "250vm23cc",
        name: "Green T-Shirt",
        description: "Product Description",
        image: "green-t-shirt.jpg",
        price: 49,
        category: "Clothing",
        quantity: 74,
        inventoryStatus: "INSTOCK",
        rating: 5,
        tradingPlan: "Plan A",
        // First image fields
        planId: "TP-1005",
        insiderName: "Emily Davis",
        relation: "VP Marketing",
        planAction: "Sell",
        adoptionDate: "05/18/2023",
        terminationDate: "",
        amendmentDate: "11/30/2023",
        expirationDate: "05/18/2025",
        durationDays: 730,
        // Second image fields
        breakdownId: "BD-1005",
        securityType: "Common Stock",
        transactionType: "Open Market Sale",
        maximumShares: 9000,
        aggregateShares: 4500,
        notionalValue: 67500,
      },
    ];
  }

  getProductsWithOrdersData() {
    return [
      {
        backupId: "1000",
        code: "f230fh0g3",
        name: "Bamboo Watch",
        description: "Product Description",
        image: "bamboo-watch.jpg",
        price: 65,
        category: "Accessories",
        quantity: 24,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1001",
        code: "nvklal433",
        name: "Black Watch",
        description: "Product Description",
        image: "black-watch.jpg",
        price: 72,
        category: "Accessories",
        quantity: 61,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1002",
        code: "zz21cz3c1",
        name: "Blue Band",
        description: "Product Description",
        image: "blue-band.jpg",
        price: 79,
        category: "Fitness",
        quantity: 2,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
      },
      {
        backupId: "1003",
        code: "244wgerg2",
        name: "Blue T-Shirt",
        description: "Product Description",
        image: "blue-t-shirt.jpg",
        price: 29,
        category: "Clothing",
        quantity: 25,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1004",
        code: "h456wer53",
        name: "Bracelet",
        description: "Product Description",
        image: "bracelet.jpg",
        price: 15,
        category: "Accessories",
        quantity: 73,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1005",
        code: "av2231fwg",
        name: "Brown Purse",
        description: "Product Description",
        image: "brown-purse.jpg",
        price: 120,
        category: "Accessories",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
      },
      {
        backupId: "1006",
        code: "bib36pfvm",
        name: "Chakra Bracelet",
        description: "Product Description",
        image: "chakra-bracelet.jpg",
        price: 32,
        category: "Accessories",
        quantity: 5,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
      },
      {
        backupId: "1007",
        code: "mbvjkgip5",
        name: "Galaxy Earrings",
        description: "Product Description",
        image: "galaxy-earrings.jpg",
        price: 34,
        category: "Accessories",
        quantity: 23,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1008",
        code: "vbb124btr",
        name: "Game Controller",
        description: "Product Description",
        image: "game-controller.jpg",
        price: 99,
        category: "Electronics",
        quantity: 2,
        inventoryStatus: "LOWSTOCK",
        rating: 4,
      },
      {
        backupId: "1009",
        code: "cm230f032",
        name: "Gaming Set",
        description: "Product Description",
        image: "gaming-set.jpg",
        price: 299,
        category: "Electronics",
        quantity: 63,
        inventoryStatus: "INSTOCK",
        rating: 3,
      },
      {
        backupId: "1010",
        code: "plb34234v",
        name: "Gold Phone Case",
        description: "Product Description",
        image: "gold-phone-case.jpg",
        price: 24,
        category: "Accessories",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
      },
      {
        backupId: "1011",
        code: "4920nnc2d",
        name: "Green Earbuds",
        description: "Product Description",
        image: "green-earbuds.jpg",
        price: 89,
        category: "Electronics",
        quantity: 23,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1012",
        code: "250vm23cc",
        name: "Green T-Shirt",
        description: "Product Description",
        image: "green-t-shirt.jpg",
        price: 49,
        category: "Clothing",
        quantity: 74,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1013",
        code: "fldsmn31b",
        name: "Grey T-Shirt",
        description: "Product Description",
        image: "grey-t-shirt.jpg",
        price: 48,
        category: "Clothing",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 3,
      },
      {
        backupId: "1014",
        code: "waas1x2as",
        name: "Headphones",
        description: "Product Description",
        image: "headphones.jpg",
        price: 175,
        category: "Electronics",
        quantity: 8,
        inventoryStatus: "LOWSTOCK",
        rating: 5,
      },
      {
        backupId: "1015",
        code: "vb34btbg5",
        name: "Light Green T-Shirt",
        description: "Product Description",
        image: "light-green-t-shirt.jpg",
        price: 49,
        category: "Clothing",
        quantity: 34,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1016",
        code: "k8l6j58jl",
        name: "Lime Band",
        description: "Product Description",
        image: "lime-band.jpg",
        price: 79,
        category: "Fitness",
        quantity: 12,
        inventoryStatus: "INSTOCK",
        rating: 3,
      },
      {
        backupId: "1017",
        code: "v435nn85n",
        name: "Mini Speakers",
        description: "Product Description",
        image: "mini-speakers.jpg",
        price: 85,
        category: "Clothing",
        quantity: 42,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1018",
        code: "09zx9c0zc",
        name: "Painted Phone Case",
        description: "Product Description",
        image: "painted-phone-case.jpg",
        price: 56,
        category: "Accessories",
        quantity: 41,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1019",
        code: "mnb5mb2m5",
        name: "Pink Band",
        description: "Product Description",
        image: "pink-band.jpg",
        price: 79,
        category: "Fitness",
        quantity: 63,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1020",
        code: "r23fwf2w3",
        name: "Pink Purse",
        description: "Product Description",
        image: "pink-purse.jpg",
        price: 110,
        category: "Accessories",
        quantity: 0,
        inventoryStatus: "OUTOFSTOCK",
        rating: 4,
      },
      {
        backupId: "1021",
        code: "pxpzczo23",
        name: "Purple Band",
        description: "Product Description",
        image: "purple-band.jpg",
        price: 79,
        category: "Fitness",
        quantity: 6,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
      },
      {
        backupId: "1022",
        code: "2c42cb5cb",
        name: "Purple Gemstone Necklace",
        description: "Product Description",
        image: "purple-gemstone-necklace.jpg",
        price: 45,
        category: "Accessories",
        quantity: 62,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1023",
        code: "5k43kkk23",
        name: "Purple T-Shirt",
        description: "Product Description",
        image: "purple-t-shirt.jpg",
        price: 49,
        category: "Clothing",
        quantity: 2,
        inventoryStatus: "LOWSTOCK",
        rating: 5,
      },
      {
        backupId: "1024",
        code: "lm2tny2k4",
        name: "Shoes",
        description: "Product Description",
        image: "shoes.jpg",
        price: 64,
        category: "Clothing",
        quantity: 0,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1025",
        code: "nbm5mv45n",
        name: "Sneakers",
        description: "Product Description",
        image: "sneakers.jpg",
        price: 78,
        category: "Clothing",
        quantity: 52,
        inventoryStatus: "INSTOCK",
        rating: 4,
      },
      {
        backupId: "1026",
        code: "zx23zc42c",
        name: "Teal T-Shirt",
        description: "Product Description",
        image: "teal-t-shirt.jpg",
        price: 49,
        category: "Clothing",
        quantity: 3,
        inventoryStatus: "LOWSTOCK",
        rating: 3,
      },
      {
        backupId: "1027",
        code: "acvx872gc",
        name: "Yellow Earbuds",
        description: "Product Description",
        image: "yellow-earbuds.jpg",
        price: 89,
        category: "Electronics",
        quantity: 35,
        inventoryStatus: "INSTOCK",
        rating: 3,
      },
      {
        backupId: "1028",
        code: "tx125ck42",
        name: "Yoga Mat",
        description: "Product Description",
        image: "yoga-mat.jpg",
        price: 20,
        category: "Fitness",
        quantity: 15,
        inventoryStatus: "INSTOCK",
        rating: 5,
      },
      {
        backupId: "1029",
        code: "gwuby345v",
        name: "Yoga Set",
        description: "Product Description",
        image: "yoga-set.jpg",
        price: 20,
        category: "Fitness",
        quantity: 25,
        inventoryStatus: "INSTOCK",
        rating: 8,
      },
    ];
  }

  getProductsMini() {
    return Promise.resolve(this.getProductsData().slice(0, 5));
  }

  getProductsSmall() {
    return Promise.resolve(this.getProductsData().slice(0, 10));
  }

  getProducts() {
    return Promise.resolve(this.getProductsData());
  }

  getProductsWithOrdersSmall() {
    return Promise.resolve(this.getProductsWithOrdersData().slice(0, 10));
  }

  getProductsWithOrders() {
    return Promise.resolve(this.getProductsWithOrdersData());
  }
}
